import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

// Get initial theme from localStorage or default to dark
const getInitialTheme = () => {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem("eventpro-theme");
    if (saved) return saved;
  }
  return "dark";
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    // Apply theme to document
    const root = document.documentElement;
    if (theme === "light") {
      root.classList.add("light");
      root.classList.remove("dark");
    } else {
      root.classList.add("dark");
      root.classList.remove("light");
    }
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("eventpro-theme", newTheme);
    return newTheme;
  };

  const setThemeValue = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem("eventpro-theme", newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme: setThemeValue }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
